import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';
import { absolute, borderRadius, faLike } from '../../styles/mixins';

export const useReportsSelectionSectionStyles = createStyles(({ token }) => ({
  subtitle: {
    height: 40,
    padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: ThemeSpaces.SPACE_NORM_20,
    backgroundColor: ThemeColors.COLOR_GREY9_9,
    ...borderRadius({ size: token.borderRadiusSM, side: 'bottom' }),
    color: ThemeColors.COLOR_GREY_BLUISH,
    boxShadow: `0 2px 6px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH7_2, 0.35)}, inset 0 -1px 8px ${ThemeColors.COLOR_GREY9_7}`,

    '.label': {
      fontWeight: 500,
      marginRight: ThemeSpaces.SPACE_NORM0_5,
      lineHeight: 1,
      textTransform: 'uppercase',
    },
  },

  subtitleLeft: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  header: {
    height: 30,
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${ThemeSpaces.SPACE_XL}px`,
    fontWeight: 'bold',
    color: ThemeColors.COLOR_GREY_BLUISH,
    borderBottom: `1px solid ${token.colorWhite}`,

    '.ant-col': {
      fontFamily: ThemeFont.FONT_CONDENSED,
    },
  },

  groupLabel: {
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'bold',
    fontSize: token.fontSizeSM,
    textTransform: 'uppercase',
    marginBottom: ThemeSpaces.SPACE_XXS - ThemeSpaces.SPACE_NORM,
  },
  groupLabelPartner: {
    color: ThemeColors.COLOR_BLUE1_5,
    fontStyle: 'italic',
  },
  groupLabelNonPartner: {
    color: token.colorPrimary,
  },

  row: {
    position: 'relative',
    height: 40,
    borderRadius: token.borderRadiusSM,
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
    fontWeight: 500,
    overflow: 'hidden',
  },
  rowEven: {
    backgroundColor: token.colorWhite,
    boxShadow: `1px 1px 12px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH4_1, 0.85)}`,
  },
  rowOdd: {
    backgroundColor: ThemeColors.COLOR_WHITE7,
    boxShadow: `1px 1px 12px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH4_1, 0.85)}`,
  },
  rowDisabled: {
    cursor: 'not-allowed',
  },

  rowContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },

  rowInner: {
    flex: 1,
    minWidth: 0,
  },
  rowInnerDisabled: {
    opacity: 0.35,
  },

  infoIcon: {
    fontSize: token.fontSizeLG,
    color: ThemeColors.COLOR_BLUE2,
    cursor: 'help',
    paddingLeft: ThemeSpaces.SPACE_SM,
  },

  rowActive: {
    ...absolute(),
    borderRadius: token.borderRadiusSM,
    border: `2px solid ${token.colorPrimary}`,

    '&::before': {
      content: "''",
      position: 'absolute',
      top: 0,
      right: 0,
      height: 55,
      width: 55,
      transform: 'translate(50%, -50%) rotateZ(45deg)',
      backgroundColor: token.colorPrimary,
    },

    '&::after': {
      ...faLike('\\f00c'),
      color: token.colorWhite,
      position: 'absolute',
      top: ThemeSpaces.SPACE_XS,
      right: ThemeSpaces.SPACE_XS,
    },
  },
}));
